<!--
 * @Author: gaoxueting
 * @Date: 2020-06-19 16:36:25
 * @LastEditTime: 2021-02-22 13:57:13
 * @LastEditors: Please set LastEditors
 * @Description:
 -->
<template>
    <div>
        <rcTable ref="rcTable"
                 style="background:#fff;padding:20px;"
                 :tableAttr="tableAttr"
                 @onSelectChange="onSelectChange">
            <Button slot="tootipL"
                    @click="refresh"
                    type="default">
                <i class="icon-common icon-refresh-o-2"></i>
            </Button>
            <Button slot="tootipL"
                    @click="applyIp()"
                    :disabled="!this.hasPermission('CB09011101')"
                    type="primary">
                <i class="icon-common icon-plus-o"></i>
                {{$i18n.t('申请虚拟IP地址')}}
            </Button>
            <Button slot="tootipL"
                    :disabled="choosed.length === 0||!this.hasPermission('CB09011104')"
                    @click="unBindIp()">
                {{$i18n.t('解绑弹性IP')}}
            </Button>
        </rcTable>

        <rcTable ref="ipRcTable"
                 style="margin-top: 10px;background:#fff;padding:20px;"
                 :tableAttr="ipTableAttr">
            <Button slot="tootipL"
                    @click="refreshIpList"
                    type="default">
                <i class="icon-common icon-refresh-o-2"></i>
            </Button>
        </rcTable>
        <!-- 编辑ip -->
        <!-- <ipForm ref="ipForm"
                @refresh="refresh" /> -->
        <applyVirIp ref="applyVirIp"
                    :envId="envId"
                    @refresh="refresh"
                    :baseInfo="baseInfo"></applyVirIp>
        <bingdip ref="bingdip"
                 @refresh="refresh"></bingdip>
        <bindHost ref="bindHost"
                  @refresh="refresh"></bindHost>
        <releaseFloatIP ref="releaseFloatIP"
                        :choosed="choosed"
                        @refresh="refresh"></releaseFloatIP>
        <bindiplist ref="bindiplist"
                    @refresh="refresh"></bindiplist>
    </div>
</template>

<script>
import dropdownlist from '@c/basic/dropdownlist'
import rcTable from '@c/basic/rcTable'
import API from '@/service/api.js'
// import ipForm from '@/views/console/mgtvpc/ipForm.vue'
import applyVirIp from '@/views/console/vpc/components/applyvirip.vue'
import bingdip from '@/views/console/vpc/components/bindip.vue'
import releaseFloatIP from '@/views/console/vpc/components/releasefloatip.vue'
import bindHost from '@/views/console/vpc/components/bindhost.vue'
import bindiplist from '@/views/console/vpc/components/bindiplist.vue'
export default {
    name: 'mgtiplist',
    props: ['envId', 'baseInfo'],
    components: {
        rcTable,
        // ipForm,
        applyVirIp,
        bingdip,
        releaseFloatIP,
        bindHost,
        bindiplist
    },
    data () {
        return {
            modal: false,
            envType: this.$route.query.envType,
            id: this.$route.params.id,
            choosed: [],
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.PORTS_SUBNET_VIPLIST, false),
                    params: {
                        subnetId: this.$route.params.id,
                        cloudEnvId: this.envId
                    }
                },
                // pageData: {
                //     pageWays: 'client'
                // },
                isWebsoct: true,
                wsKey: 'id',
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: true,
                columnsChooseShow: true,
                columns: [
                    {
                        title: this.$t('虚拟IP地址'),
                        key: 'fixedIp',
                        columnShow: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.fixedIp }, class: 'rc-ellipsis' }, params.row.fixedIp)
                        }
                    },
                    {
                        title: this.$t('绑定的弹性IP'),
                        key: 'floatingIpAddress',
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.floatingIpAddress || '--' }, class: 'rc-ellipsis' }, params.row.floatingIpAddress || '--')
                        }
                    },
                    {
                        title: this.$t('绑定的云主机（网卡）'),
                        key: 'instanceInfo',
                        columnShow: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('div', [
                                h('p', { attrs: { title: params.row.instanceInfo || '--' }, class: 'rc-ellipsis' }, params.row.instanceInfo || '--'),
                                h('a', {
                                    style: {
                                        display: params.row.instanceNm > 1 ? 'block' : 'none'
                                    },
                                    // directives: [{ name: 'auth' }],
                                    // class: { 'disabled-per': destroyDisabled },
                                    on: { click: () => this.viewMore(params.row) }
                                }, this.$t('查看更多'))
                            ])
                        }
                    },
                    {
                        title: this.$t('操作'),
                        key: 'operate',
                        width: 240,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            let arr = []
                            if (params.row.floatingIpAddress) {
                                arr = [
                                    h('a', {
                                        // directives: [{ name: 'auth' }],
                                        class: { disabled: !this.hasPermission('CB09011104') },
                                        on: { click: () => this.hasPermission('CB09011104') && this.unBindIpFun(params.row) }
                                    }, this.$t('解绑弹性IP'))
                                ]
                            } else {
                                arr = [
                                    h('a', {
                                        // directives: [{ name: 'auth' }],
                                        class: { disabled: !this.hasPermission('CB09011103') },
                                        on: { click: () => this.hasPermission('CB09011103') && this.bindIp(params.row) }
                                    }, this.$t('绑定弹性IP'))
                                ]
                            }
                            arr.push(h('a', {
                                // directives: [{ name: 'auth' }],
                                class: { disabled: !this.hasPermission('CB09011105') },
                                on: { click: () => this.hasPermission('CB09011105') && this.bindingHost(params.row) }
                            }, this.$t('绑定服务器')))

                            // const per = this.hasPermission('MD1004') || this.hasPermission('MD1008')
                            arr = arr.concat([
                                h(dropdownlist, {
                                    props: {
                                        operateConfig: this.configBtn(params.row)
                                    },
                                    style: 'cursor:pointer;display:inline-block;margin-left: 5px;',
                                    on: { event: (type) => { this.operate(type, params.row) } }
                                })
                            ])
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, arr)
                        }

                    }
                ]
            },
            ipTableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.PORTS_SUBNET_IPLIST, false),
                    params: {
                        subnetId: this.id1 || this.$route.params.id,
                        cloudEnvId: this.envId
                    }
                },
                isWebsoct: true,
                wsKey: 'id',
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: false,
                columnsChooseShow: true,
                columns: [
                    {
                        title: this.$t('IP地址'),
                        key: 'fixedIp',
                        columnShow: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.fixedIp }, class: 'rc-ellipsis' }, params.row.fixedIp)
                        }
                    },
                    {
                        title: this.$t('用途'),
                        key: 'status',
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.purpose || '--' }, class: 'rc-ellipsis' }, params.row.purpose || '--')
                        }
                    },
                    {
                        title: this.$t('操作'),
                        key: 'operate',
                        width: 240,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            const arr = [
                                h('a', {
                                    // directives: [{ name: 'auth' }],
                                    class: { disabled: !this.hasPermission('CB09011102') },
                                    on: { click: () => this.hasPermission('CB09011102') && this.deleteIP(params.row) }
                                }, this.$t('删除'))
                            ]
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, arr)
                        }
                    }
                    // {
                    //     title: this.$t('操作'),
                    //     key: 'operate',
                    //     width: 240,
                    //     columnShow: true,
                    //     disabledSearch: true,
                    //     columnsChoosed: true,
                    //     render: (h, params) => {
                    //         let arr = [
                    //             h('a', {
                    //                 directives: [{ name: 'auth' }],
                    //                 // class: { 'disabled-per': !this.hasPermission('MD1006') },
                    //                 on: { click: () => this.deleteIP(params.row) }
                    //             }, this.$t('删除'))
                    //         ]
                    //         return h('div', {
                    //             class: 'tbl-operate'
                    //         }, arr)
                    //     }
                    // }
                ]
            }
        }
    },
    methods: {
        onSelectChange (rows) {
            this.choosed = rows
        },
        refresh () {
            this.$refs.rcTable.refreshTable()
            this.$emit('refreshSubnet')
        },
        refreshIpList () {
            this.$refs.ipRcTable.refreshTable()
        },
        asynIP () {
            this.axios.put(this.urlFormat(API.PUT_NET_IP_SYNC, false, [this.id])).then(res => {
                this.$Notice.info({
                    title: this.$t('后台已经开始同步操作'),
                    duration: ''
                })
                this.refresh()
            })
        },
        // 跳转到实例详情页面
        gotoInstanceDetail (row) {
            if (row.instanceType === 'RES_HOST') {
                // 跳转到计算主机列表
                this.$router.push({
                    path: `mgt/env/host/${row.allocateTargetId}`,
                    query: {
                        envType: this.envType,
                        envName: this.envName || this.$route.query.envName
                    }
                })
            } else {
                this.$router.push({
                    path: `/mgt/host/cloudy/${row.allocateTargetId}/detail`,
                    query: { envType: this.envType, quote: 'host' }
                })
            }
        },
        applyIp (row) {
            this.$refs.applyVirIp.openModal(row)
        },
        viewMore (row) {
            this.$refs.bindiplist.openModal(row)
        },
        // 生成更多按钮
        configBtn: function (obj) {
            const btnConfig = []
            btnConfig.push({ value: 'unbindHost', btnName: this.$t('解绑服务器'), display: true, disabled: !this.hasPermission('CB09011106') })
            // if (this.hasPermission('MD1008')) {
            btnConfig.push({ value: 'delete', btnName: this.$t('删除'), display: true, disabled: !this.hasPermission('CB09011102') })
            // }
            return JSON.stringify(btnConfig)
        },
        // 更多按钮事件分发
        operate: function (operateType, row) {
            switch (operateType) {
                case 'unbindHost':
                    if (!this.hasPermission('CB09011106')) return
                    this.unbindHost(row)
                    break
                case 'delete':
                    if (!this.hasPermission('CB09011102')) return
                    this.delete(row)
                    break
            }
        },
        bindIp (row) {
            this.$refs.bingdip.openModal(row)
        },
        unBindIp () {
            this.$refs.releaseFloatIP.openModal(this.choosed)
        },
        unBindIpFun (row) {
            this.choosed = [row]
            this.$refs.releaseFloatIP.openModal(this.choosed)
        },
        bindHost (row) {
            // this.$refs.bindHost.openModal(row)
        },
        bindingHost (row) {
            this.$refs.bindHost.openModal(row)
        },
        unbindHost (row) {
            this.$refs.bindiplist.openModal(row)
            // this.$rcNewModal({
            //     message: this.$t('您确定要解绑该弹性IP绑定的云主机吗？') + '<br />',
            //     //  tips: this.$t('删除前请先确认云服务器卸载已挂载的文件系统。') + '\n' + this.$t('删除后将无法恢复，请谨慎操作。'),
            //     callback: () => {
            //         this.axios.post(API.POST_DETACH_SERVER, {
            //             params: {
            //                 portId: row.id,
            //                 vmId: row.id
            //             }
            //         }).then(res => {
            //             this.refresh()
            //         })
            //     }
            // })
        },
        delete (row) {
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: this.$t('您确定要删除该虚拟IP地址吗？'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.GET_PORTS + '/' + row.id, false)).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        deleteIP (row) {

        }
    }
}
</script>
<style lang="less" scoped>
.tips-msg {
    margin-top: 10px;
    color: #b3b3b3;
}
</style>
